const initialState = {
  isFetching: false,
  error: false,
  data: {},
  pageData: {},
  activeTab: 'MANAGE_PLANS'
}
const ildtabState = (state = initialState, action) => {
  switch (action.type) {
    case 'TAB_CHANGE':{
      return Object.assign({}, state, { isFetching: false, error: false, data: {}, activeTab: action.data });
    }
    default:
      return state;

  }
};


export default ildtabState;